import React, { useState } from 'react';
import useBrandContext from 'contexts/brand.context';
import EditBrandOpeningTime from './edit-brand-opening-time';
import PreviewBrandOpeningTime from './preview-brand-opening-time';
import PageHeaderText from 'components/base/page-header-text';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';
import { Breadcrumbs } from '@cokitchen/cokitchen-components';
const BrandDetailsOpeningTime = () => {
  const { activeBrand } = useBrandContext();
  const [editing, setEditing] = useState(false);

  const breadcrumbs = [
    { name: 'Overview', path: `${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.OVERVIEW}` },
    {
      name: `${activeBrand?.name}`,
      path: ''
    }
  ];
  return (
    <div>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <PageHeaderText
        title={activeBrand?.name ?? 'brand'}
        description={`Update ${activeBrand?.name ?? 'brand'} details here`}>
        {!editing && (
          <button
            className='border border-[#E7E8E9] shadow text-[#5C5F64] w-[86px] h-[40px] py-2 rounded-[8px]'
            onClick={() => {
              setEditing(true);
            }}>
            Edit
          </button>
        )}
      </PageHeaderText>
      {editing ? <EditBrandOpeningTime /> : <PreviewBrandOpeningTime />}
    </div>
  );
};

export default BrandDetailsOpeningTime;
